import { z } from 'zod';

// 6-digit TOTP code or 10-char base32 backup (with optional dash).
const TOTP_RX = /^\d{6}$/;
const BACKUP_RX = /^[A-Za-z2-7]{5}-?[A-Za-z2-7]{5}$/;

export const totpCodeSchema = z
  .string()
  .trim()
  .refine((v) => TOTP_RX.test(v.replace(/\s+/g, '')), {
    message: 'รหัสต้องเป็นตัวเลข 6 หลัก',
  });

export const totpOrBackupCodeSchema = z
  .string()
  .trim()
  .refine(
    (v) => {
      const cleaned = v.replace(/\s+/g, '');
      return TOTP_RX.test(cleaned) || BACKUP_RX.test(cleaned);
    },
    { message: 'รหัสไม่ถูกต้อง — ใส่ 6 หลัก หรือ backup code' },
  );

export const passwordConfirmSchema = z.string().min(1, 'กรุณาใส่รหัสผ่าน').max(200);

/* enable: client posts the secret returned by /setup along with the
   confirmation code from the authenticator app. */
export const twoFactorEnableSchema = z.object({
  secret: z
    .string()
    .min(16)
    .max(64)
    .regex(/^[A-Z2-7]+$/, 'รูปแบบ secret ไม่ถูกต้อง'),
  code: totpCodeSchema,
  password: passwordConfirmSchema,
});

export const twoFactorDisableSchema = z.object({
  code: totpOrBackupCodeSchema,
  password: passwordConfirmSchema,
});

export const twoFactorRegenerateSchema = z.object({
  code: totpOrBackupCodeSchema,
  password: passwordConfirmSchema,
});

/* /auth/2fa/verify — finishes a 2-step login. Client passes the challenge
   token issued by /login plus the code from their authenticator (or a
   backup code). */
export const twoFactorChallengeVerifySchema = z.object({
  challenge: z.string().min(10).max(2000),
  code: totpOrBackupCodeSchema,
});

export type TwoFactorEnableInput = z.infer<typeof twoFactorEnableSchema>;
export type TwoFactorDisableInput = z.infer<typeof twoFactorDisableSchema>;
export type TwoFactorRegenerateInput = z.infer<typeof twoFactorRegenerateSchema>;
export type TwoFactorChallengeVerifyInput = z.infer<typeof twoFactorChallengeVerifySchema>;
